import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#007754\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#finger-print_svg__a)\"><path d=\"M23.25 15.75v6a1.5 1.5 0 0 1-1.5 1.5h-6m0-22.5h6a1.5 1.5 0 0 1 1.5 1.5v6m-22.5 0v-6a1.5 1.5 0 0 1 1.5-1.5h6m0 22.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6M18 13.875v-1.5c0-3.713-2.7-6.75-6-6.75s-6 3.037-6 6.75v6m12 0v-1.5m-9 0v1.5\"></path><path d=\"M15 18.375v-5.25c0-2.063-1.35-3.75-3-3.75s-3 1.687-3 3.75v.75m3 3.75v.75m0-6v2.25\"></path></g><defs><clipPath id=\"finger-print_svg__a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }